import { render, staticRenderFns } from "./group-selected-filters.vue?vue&type=template&id=92f87556&"
import script from "./group-selected-filters.vue?vue&type=script&lang=ts&"
export * from "./group-selected-filters.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports